<template>
  <div class="content" id="thankyoupage">
    <div class="wrapper-1">
      <div class="wrapper-2">
        <h2 class="mb-5 fw-bold">Gracias !!!</h2>
        <p class="text-dark pb-4" v-if="orden !== undefined"># de orden:{{ orden }}</p>
        <p>Gracias por tu compra, tu orden ha sido confirmada.</p>
        <p>Pronto te llegara un correo de confirmación.</p>
        <a href="/">
            <button class="go-home my-5">Inicio</button>
        </a>
      </div>
      <div class="footer-like py-2">
        <img class="router-link-active" src="images/img_estilos/MMK_Logo.png" alt="logo" style="height: 30px; width: 100%; object-fit: contain; cursor: pointer;">
      </div>
    </div>
  </div>
</template>
  
<script>
const axios = require("axios");
export default {
  name: "thankYouPage",
  data() {
    return {
      orden: undefined,
      api_url: process.env.VUE_APP_SUSCRIPTIONS_ROUTE,
    };
  },
  components: {},
  mounted() {
    console.log(localStorage.getItem('metodoPago'));

    if(localStorage.getItem('metodoPago') === "stripe"){
      // STRIPE 
      console.log("stripe");
      window.dataLayer.push({
        'event': 'productoComprado por Stripe',
        'pageURL': this.$router.currentRoute.fullPath,
        'subscription': JSON.parse(localStorage.getItem('temporalProducts')),
        'dateOfPurchase': new Date().toLocaleString('en-US')
      });
      setTimeout(() => {
        this.clearCart();
      }, 1000);
    }
    else if(localStorage.getItem('metodoPago') === "paypal"){
      // PAYPAL
      console.log("paypal");
      this.orden = this.$route.params.order;
      window.dataLayer.push({
        'event': 'suscripcionComprada',
        'pageURL': this.$router.currentRoute.fullPath,
        'subscription': JSON.parse(localStorage.getItem('temporalProducts')),
        'dateOfPurchase': new Date().toLocaleString('en-US')
      });
      setTimeout(() => {
          this.clearCart();
      }, 1000);
    }
  },
  methods:{
    clearCart() {
      if($cookies.get("uidmmkg")){
        this.$store.commit('finishStore');
        localStorage.removeItem("temporalProducts");
        localStorage.removeItem('temporalAddressPaypal');
        localStorage.removeItem('temporalAddressIdPaypal');
        localStorage.removeItem('temporalProductsPaypal');
        localStorage.removeItem('temporalCodeCouponPaypal');
        localStorage.removeItem("metodoPago")
        
        //Vaciando datos de el carrito de el servidor
        axios({
            method: "POST",
            url: this.api_url + "/cart/empty-cart/" + $cookies.get("uidmmkg"),
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + $cookies.get("ctoken"),
            },
        })
        .then((response) => {
            if (response.data.status) {
                console.log("limpiando carrito: ", response.data);
            } else {
                console.log(response.data.message);
            }
        })
        .catch((error) => {
            console.error(error);
        });
      }
    }
  }
};
</script>
  
  <style lang="scss" scoped>
  body{
background: #ffffff;
background: linear-gradient(to bottom, #ffffff 0%,#e1e8ed 100%);
filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#e1e8ed',GradientType=0 );
    height: 100%;
        margin: 0;
        background-repeat: no-repeat;
        background-attachment: fixed;
}

#thankyoupage{
    margin:100px auto;
}

.wrapper-1{
  width:100%;
  height:100vh;
  display: flex;
  flex-direction: column;
}
.wrapper-2{
  padding :30px;
  text-align:center;
}
h2{
  font-size:4em;
  letter-spacing:0px;
  color:#4051b5 ;
  margin:0;
  margin-bottom:20px;
  border-color: #f2f2f2;
  font-weight: 900;
}
.wrapper-2 p{
  margin:0;
  font-size:1.2em;
  color:foestgreen;
  font-family: 'Source Sans Pro', sans-serif;
  letter-spacing:1px;
}
.go-home{
  color:#fff;
  background:#4151b5;
  border:none;
  padding:7px 50px;
  margin:30px 0;
  border-radius:30px;
  text-transform:capitalize;
  box-shadow: 0 10px 16px 1px rgba(174, 199, 251, 1);
  font-weight:900;
  letter-spacing:0px;
  text-transform: uppercase;

}
.footer-like{
  margin-top: auto; 
  background:#8BC34A;
  padding:6px;
  text-align:center;
}
.footer-like p{
  margin:0;
  padding:4px;
  color:#fff;
  font-family: 'Source Sans Pro', sans-serif;
  letter-spacing:1px;
}
.footer-like p a{
  text-decoration:none;
  color:#5892FF;
  font-weight:600;
}

@media (min-width:360px){
  h1{
    font-size:4.5em;
  }
  .go-home{
    margin-bottom:20px;
  }
}

@media (min-width:600px){
  .content{
  max-width:1000px;
  margin:0 auto;
}
  .wrapper-1{
  height: initial;
  max-width:620px;
  margin:0 auto;
  margin-top:50px;
  box-shadow: 4px 8px 40px 8px rgba(203, 217, 243, 0.2);
}
  
}
</style>
  